import { useEffect } from "react";

// Intended production domain (recorded, not yet attached — no DNS change made).
// Canonical/OG URLs follow the serving host at runtime; the sitemap and
// robots.txt are switched by scripts/set-production-domain.sh at domain attach.
export const PROD_ORIGIN = "https://www.80metrics.com.au";
const PROD_HOSTS = ["www.80metrics.com.au", "80metrics.com.au"];

const isProdHost = () =>
  typeof window !== "undefined" && PROD_HOSTS.includes(window.location.hostname);

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export function Seo({ title, description, robots, jsonLd = [] }) {
  const canonical = window.location.origin + window.location.pathname;
  const jsonKey = JSON.stringify(jsonLd);
  useEffect(() => {
    document.title = title;
    if (description) setMeta("name", "description", description);
    // Preview/staging hosts stay out of the index; the production host indexes.
    // Pages can force their own robots value (payment + unsubscribe pages).
    // Note: applied client-side after render — see LAUNCH_STATUS.md tradeoffs.
    setMeta("name", "robots", robots || (isProdHost() ? "index, follow" : "noindex, nofollow"));
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = canonical;
    setMeta("property", "og:title", title);
    setMeta("property", "og:type", "website");
    if (description) setMeta("property", "og:description", description);
    setMeta("property", "og:url", canonical);
    const scripts = jsonLd.map((data) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.text = JSON.stringify(data);
      document.head.appendChild(s);
      return s;
    });
    return () => scripts.forEach((s) => s.remove());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, robots, canonical, jsonKey]);
  return null;
}

export const ORG_LD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "80 Metrics Property Advisory",
  description:
    "Independent, evidence-based property advisory for buying, selling and retaining property. 80+ metrics. Clearer decisions.",
  founder: {
    "@type": "Person",
    name: "Matthew Clark",
    jobTitle: "Founder & Head of Client Strategy",
  },
  areaServed: "Australia",
};

export const MATTHEW_LD = {
  "@context": "https://schema.org",
  "@type": "Person",
  name: "Matthew Clark",
  jobTitle: "Founder & Head of Client Strategy",
  worksFor: { "@type": "Organization", name: "80 Metrics Property Advisory" },
  description:
    "Dip. Prop. (Agency Mgmt) · QPIA · Dip. Fin. Services. Two-time Amazon bestselling author on property investment. Key Choice Group Pty Ltd trading as 80 Metrics Property Advisory holds Corporate Estate Agent’s Licence 093462L.",
};

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: window.location.origin + it.path,
  })),
});
